export interface UserPreferences {
  language: string;
  avatar?: string;
  username?: string;
  _id: string;
  firstName?: string;
  lastName?: string;
}

export const defaultUserPreferences: UserPreferences = {
  language: "",
  avatar: "",
  username: "",
  _id: "",
  firstName: "",
  lastName: "",
};

export enum AppStatus {
  checking = "checking",
  allowed = "allowed",
  denied = "denied",
}
